// extracted by mini-css-extract-plugin
export var errorIcon = "_mw-1";
export var nameLogo = "_mw-0";